import { faInfoCircle, faTimes } from "@fortawesome/pro-regular-svg-icons";

import { Button } from "src/base-components/Button";
import { Divider } from "src/base-components/Divider";
import { Icon } from "src/base-components/Icon";
import { Tooltip } from "src/design-system/Tooltip";
import { SchemaEditorSidebarProps } from "src/schema/schemaEditor/types";

export const SchemaEditorSidebar: React.FC<SchemaEditorSidebarProps> = ({
  canSave,
  isSaving,
  schema,
  onClose,
  title,
  tooltipText,
  children,
}) => {
  return (
    <div className="decideScrollbar flex h-full w-150 shrink-0 flex-col gap-y-4 border-l border-gray-100 bg-white pb-5">
      <div className="sticky top-0 z-20 flex flex-col gap-y-4 bg-white px-4 pt-5">
        <div className="flex items-center gap-x-1.5">
          <div className="flex-1 text-gray-800 font-inter-semibold-13px">
            {title}
          </div>
          <Button
            disabled={!schema || !canSave || isSaving}
            htmlType="submit"
            loading={isSaving}
            size="sm"
          >
            Save changes
          </Button>
          <Tooltip body={tooltipText} placement="top-end">
            <Icon color="text-gray-500" icon={faInfoCircle} size="xs" />
          </Tooltip>
          <Icon
            color="text-gray-500"
            icon={faTimes}
            size="xs"
            onClick={onClose}
          />
        </div>
        <Divider />
      </div>
      <div className="flex flex-col gap-y-4 px-4">{children}</div>
    </div>
  );
};
